import { combineReducers } from 'redux';
import { createReducer } from '../utils';

const TOGGLE_GROUP = 'TOGGLE_GROUP';

function toggleGroup(lockingId) {
	return {
		type: TOGGLE_GROUP,
		lockingId
	};
}

const initialState = {};

const reducer = createReducer(initialState, {
	[TOGGLE_GROUP]: (state, action) => {
		const isCollapsed = state[action.lockingId];
		return {
			...state,
			[action.lockingId]: isCollapsed ? false : true
		};
	}
});

function getCollapsedGroups(state) {
	return state.app.collapsedGroups;
}

export default reducer;
export { toggleGroup, getCollapsedGroups };



// WEBPACK FOOTER //
// ./src/js/reducers/app/collapsedGroups.js